import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Upload, Select, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { app } from "../firebase";
import { apiGet, apiPost, apiPut } from "../Utils/api";
import styled from "styled-components";
import { toast } from "react-toastify";
import {
  deleteFileFromR2,
  uploadFileToCloudflare,
  uploadFileToR2,
} from "../Utils/commonFunction";
import { fixCapcutLink } from "../Utils/capcutLinkFixer";

const { Option } = Select;

const AddFeedModal = ({
  isVisible,
  onClose,
  fetchFeeds,
  feedToEdit,
  setPage,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const storage = getStorage(app);
  const image_url = process.env.REACT_APP_IMAGE_BASEURL;

  const uploadFileToStorage = async (file, path) => {
    if (!file && !path) throw new Error("No file provided");
    console.log(path, "path");

    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    return getDownloadURL(storageRef);
  };

  const deleteFileFromStorage = async (path) => {
    const storageRef = ref(storage, path);
    await deleteObject(storageRef);
  };

  const fetchCategories = async () => {
    setCategoryLoading(true);
    try {
      const data = await apiGet("/api/categories");
      const categoryList = (data?.categories || []).map((cat, index) => ({
        key: cat.id,
        id: cat.id,
        sNo: index + 1,
        name: cat.name,
        value: cat.name,
      }));
      setCategories(categoryList);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error fetching categories");
    } finally {
      setCategoryLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    console.log("Form values:", values);
    setLoading(true);
    try {
      const {
        name,
        thumbnail,
        video,
        categories,
        capcut_link,
        telegram_link,
        whatsapp_link,
      } = values;

      if (!thumbnail || !thumbnail.originFileObj) {
        throw new Error("Thumbnail file is missing.");
      }
      if (!video || !video.originFileObj) {
        throw new Error("Video file is missing.");
      }
      let thumbnailUrl = "thumbnails/" + thumbnail.originFileObj.name;
      let videoUrl = "videos/" + video.originFileObj.name;
      try {
        await uploadFileToR2(thumbnail.originFileObj, thumbnailUrl);
        await uploadFileToR2(video.originFileObj, videoUrl);
      } catch (e) {
        console.log(e, "sfvsgbsfEGESDSX");
      }
      thumbnailUrl = image_url + "/thumbnails/" + thumbnail.originFileObj.name;
      videoUrl = image_url + "/videos/" + video.originFileObj.name;

      const newFeed = {
        name,
        thumbnail: thumbnailUrl,
        video: videoUrl,
        categories_name: categories,
        download_count: 0,
        view_count: 0,
        capcut_link: fixCapcutLink(capcut_link, window.location.origin),
        whatsapp_link: whatsapp_link,
        telegram_link: telegram_link,
        created_at: Date.now(),
      };

      await apiPost("/api/feeds", newFeed);

      toast.success("Feed added successfully!");
      form.resetFields();
      onClose();
      setPage(1);
      fetchFeeds(false);
    } catch (error) {
      console.error("Error adding feed:", error);
      toast.error(error.message || "Failed to add feed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      let updatedThumbnailUrl = feedToEdit.imageUrl;
      const newThumbnailFile = values.thumbnail?.originFileObj;

      if (newThumbnailFile) {
        updatedThumbnailUrl =
          image_url + "/thumbnails/" + newThumbnailFile.name;
        await uploadFileToR2(
          newThumbnailFile,
          `thumbnails/${newThumbnailFile.name}`
        );
        const oldThumbnailPath = feedToEdit.imageUrl;
        if (oldThumbnailPath) {
          const bucketPath = oldThumbnailPath?.split(image_url)[1];
          await deleteFileFromR2(bucketPath);
        }
      }
      const updatedFeed = {
        name: values.name,
        thumbnail: updatedThumbnailUrl,
        video: feedToEdit.videoUrl,
        categories_name: values.categories,
        capcut_link: fixCapcutLink(values.capcut_link, window.location.origin),
        whatsapp_link: values.whatsapp_link,
        telegram_link: values.telegram_link,
      };

      await apiPut(`/api/feeds/${feedToEdit.id}`, updatedFeed);
      toast.success("Feed updated successfully!");
      form.resetFields();
      onClose();
      setPage(1);
      fetchFeeds(false);
    } catch (error) {
      console.error("Error updating feed:", error);
      toast.error(error.message || "Failed to update feed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      prefixCls="create-feed-modal"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={feedToEdit ? handleUpdate : handleSubmit}
        initialValues={{
          categories: feedToEdit?.categories || [],
          name: feedToEdit?.name || "",
          capcut_link: feedToEdit?.capcut_link || "",
          whatsapp_link: feedToEdit?.whatsapp_link || "",
          telegram_link: feedToEdit?.telegram_link || "",
          thumbnail: feedToEdit?.imageUrl || "",
          video: feedToEdit?.videoUrl || "",
        }}
      >
        <ModalStyle>
          <h2>{feedToEdit ? "Edit" : "Create New"} Feed</h2>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: "Please enter the feed name!" }]}
          >
            <Input placeholder="Enter feed name" />
          </Form.Item>

          <Form.Item
            name="capcut_link"
            label="Capcut Link"
            rules={[{ required: true, message: "Capcut link is required" }]}
          >
            <Input placeholder="Paste the Capcut link" />
          </Form.Item>

          <Form.Item
            name="whatsapp_link"
            label="Whatsapp Link"
            rules={[{ required: true, message: "Whatsapp link is required" }]}
          >
            <Input placeholder="Paste the Whatsapp link" />
          </Form.Item>

          <Form.Item
            name="telegram_link"
            label="Telegram Link"
            rules={[{ required: true, message: "Telegram link is required" }]}
          >
            <Input placeholder="Paste the Telegram link" />
          </Form.Item>

          <Form.Item
            name="thumbnail"
            label="Thumbnail"
            rules={[{ required: true, message: "Please upload a thumbnail!" }]}
          >
            <div style={{ width: "100%" }}>
              <Upload
                style={{ width: "100%" }}
                accept="image/*"
                maxCount={1}
                beforeUpload={() => false}
                listType="picture"
                defaultFileList={
                  feedToEdit?.imageUrl &&
                  !form.getFieldValue("thumbnail") && [
                    {
                      uid: "1",
                      name: "thumbnail.png",
                      status: "done",
                      url: feedToEdit.imageUrl,
                    },
                  ]
                }
                onChange={({ fileList }) =>
                  form.setFieldValue("thumbnail", fileList[0])
                }
              >
                <Button
                  style={{ width: "100%", minWidth: "470px" }}
                  icon={<UploadOutlined />}
                >
                  Upload Thumbnail
                </Button>
              </Upload>
            </div>
          </Form.Item>

          {!feedToEdit && (
            <Form.Item
              name="video"
              label="Video"
              rules={[{ required: true, message: "Please upload a video!" }]}
            >
              <div style={{ width: "100%" }}>
                <Upload
                  style={{ width: "100%" }}
                  accept="video/*"
                  maxCount={1}
                  beforeUpload={() => false}
                  listType="text"
                  onChange={({ fileList }) =>
                    form.setFieldValue("video", fileList[0])
                  }
                >
                  <Button
                    style={{ width: "100%", minWidth: "470px" }}
                    icon={<UploadOutlined />}
                  >
                    Upload Video
                  </Button>
                </Upload>
              </div>
            </Form.Item>
          )}

          <Form.Item
            name="categories"
            label="Categories"
            rules={[
              {
                required: true,
                message: "Please select at least one category!",
              },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="Select categories"
              value={form.getFieldValue("categories")}
              allowClear
              loading={categoryLoading}
            >
              {(categories ?? [])?.map((category) => (
                <Option value={category.value} key={category.key}>
                  {category.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button
              className="create-btn"
              htmlType="submit"
              disabled={loading}
              loading={loading}
            >
              {feedToEdit ? "Update" : "Create"}
            </Button>
            {/* <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button> */}
          </Form.Item>
        </ModalStyle>
      </Form>
    </Modal>
  );
};

export default AddFeedModal;

const ModalStyle = styled.div`
  width: 100%;

  h2 {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #000000;
  }

  &.ant-form-item {
    margin-bottom: 5px !important;
  }
  .create-btn {
    width: 100%;
    height: 40px;
    background: #28a3a9;
    border-radius: 6px;
    font-weight: 500;
    border-style: none;
    color: #ffffff;
    margin-top: 10px;
    font-size: 15px;
    font-family: "Poppins", sans-serif;
    cursor: pointer;

    &:hover {
      color: #ffffff !important;
      background: #28a3a9 !important;
    }
  }
`;
